module.exports = __webpack_public_path__ + "static/media/History_of_Protestantism_vol_2-s.b3677986.jpg";